import animationRule from './extraUtil/genericAnimationRule';
export default function chartConfigGenerator (config) {
    return {
        type: config.type,
        width: config.width || '100%',
        height: config.height || '100%',
        creditLabel: false,
        dataFormat: config.dataFormat || 'json',
        dataEmptyMessage: '',
        animation: animationRule,
        dataSource: config.dataSource(config.data, config.timeSelectorValue, config.theme || 'dark', config.allShipperData || [])
    }
}


// WEBPACK FOOTER //
// ./src/util/chartConfigGenerator.js